import { TextType } from "@/components/text-type";
import * as m from "@/paraglide/messages";

import { Birds } from "./birds";
import { CopilotCard } from "./copilot-card";

export function HeroSection() {
	const animatedWord = m.landing_hero_teachAnimated();

	return (
		<section className="relative px-4 pt-16 pb-10 md:px-12 md:pt-24">
			<div className="mx-auto max-w-6xl">
				{/* Headline */}
				<div className="relative mx-auto max-w-3xl text-center">
					<h1 className="text-balance text-5xl font-bold leading-[1.05] tracking-tight text-foreground md:text-7xl">
						{m.landing_hero_teachPrefix()}
						<span className="relative inline-block italic text-primary">
							<span aria-hidden className="invisible">
								{animatedWord}
							</span>
							<TextType
								as="span"
								className="absolute inset-0"
								text={animatedWord}
								loop={false}
								typingSpeed={150}
								showCursor={false}
							/>
							<SquiggleUnderline className="absolute -bottom-2 left-0 h-3 w-full text-primary" />
							<Birds />
						</span>
						{m.landing_hero_line1Suffix()}
						<br />
						{m.landing_hero_line2()}
					</h1>
					<p className="mx-auto mt-6 max-w-xl text-lg text-muted-foreground md:text-xl">
						{m.landing_hero_subtitle()}
					</p>
				</div>

				<CopilotCard className="mt-12" heading={m.landing_hero_copilotHeading()} />
			</div>
		</section>
	);
}

function SquiggleUnderline({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 220 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			preserveAspectRatio="none"
			aria-hidden
		>
			<path
				d="M2 8 Q 30 -2 60 6 T 120 6 T 180 6 T 218 6"
				stroke="currentColor"
				strokeWidth="3"
				strokeLinecap="round"
				fill="none"
			/>
		</svg>
	);
}
